<fgb-page-header [pageTitle]="'terms.page.title'" [showBalance]="false" [backButtonLink]="'/'"></fgb-page-header>
<div class="container">
  <div class="row">
    <div class="col-12">
      <div class="term-container card border mt-lg-3">
        <fgbcl-terms-and-conditions [type]="termsAndConditionsType" [defaultTerms]="defaultTemplate"></fgbcl-terms-and-conditions>
      </div>
    </div>
  </div>
</div>

<ng-template #defaultTemplate>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
